import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { BackgroundImage, Image, withContent } from '@bubbletea/core';
import { motion } from 'framer-motion';
import { useTheme } from 'styled-components';
import Title from '../../UI/Title';
import { IContent } from '../../../types';
import { CaptionText, Content, ContentWrapper, InfoSection, ShapeContainer } from './styles';
import { IMainTheme } from '../../../types/theme';
import sendEvent from '../../../utils/sendEvent';
import { IStoreState } from '../../../types/store';

interface IAboutProps {
  context: IContent;
}

const About = ({ context }: IAboutProps) => {
  const [impressionEventRegistered, setImpressionEventRegistered] = useState(false);
  const contentSelector = useSelector((state: IStoreState) => ({
    analyticsLoaded: state.app.analyticsLoaded,
  }));
  const { analyticsLoaded } = contentSelector;

  useEffect(() => {
    const impressionEventDetails = {
      location: 'reinsurance banner',
      category: 'scroll',
      locationPosition: process.env['REACT_APP_PAGE_TYPE'] === 'subscriber' ? 7 : 6,
      action: 'visible',
    };
    if (analyticsLoaded && impressionEventRegistered) {
      setImpressionEventRegistered(false);
      sendEvent(impressionEventDetails, 'impressionevent');
    }
  }, [impressionEventRegistered, analyticsLoaded]);

  const theme = useTheme() as IMainTheme;
  const { googlesheet } = context;
  const { reinsurance } = googlesheet;

  const upcShapeSuffix = theme.name === 'uplay' ? '-upc' : '';

  return (
    <ContentWrapper
      id={'reinsurance'}
      whileInView={'sendevent'}
      onAnimationStart={() => setImpressionEventRegistered(true)}
      viewport={{ once: true }}
    >
      <BackgroundImage imageNames={['bg-reinsurance.svg']} classNames={['reinsurance-bg']} dynamic />
      <ShapeContainer>
        <Image
          imageNames={[`shape-reinsurance${upcShapeSuffix}.svg`]}
          classNames={['reinsurance-shape']}
          dynamic
          altText={''}
        />
      </ShapeContainer>
      <Content className="section-wrapper">
        <motion.div
          initial={{
            opacity: 0,
            y: -5,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          transition={{
            type: 'spring',
            delay: 0.5,
          }}
          viewport={{ once: true }}
        >
          <Image imageNames={['guy.png']} classNames={['guy']} altText="Guy playing Guitar" dynamic />
        </motion.div>
        <InfoSection>
          <Title>{reinsurance.title}</Title>
          <p dangerouslySetInnerHTML={{ __html: reinsurance.description as string }} />
          <CaptionText dangerouslySetInnerHTML={{ __html: reinsurance.caption as string }} />
        </InfoSection>
      </Content>
    </ContentWrapper>
  );
};

export default withContent(About);
